export default function setGeolocation({ lat, lon }) {
  return `${lat};${lon}`
}
